module.exports = __webpack_public_path__ + "img/icon-gen-subscriber.12b006d5.png";